import React from 'react';
import { MarkerStyled } from './styled';
export const Marker = ({ color = 'success', position = { vertical: 'top', horizontal: 'right' }, visible = true, inLabel = false, wide = false }) => (React.createElement(MarkerStyled, { "$position": position, "$visible": visible, "$color": color, "$wide": wide, "$inLabel": inLabel }));
